export default __webpack_public_path__ + "static/media/ke.caecf5fd.jpg";